
import gql from 'graphql-tag'
export default gql`
  mutation provokeViLabel ($input: provokeViLabelInput!) {
    provokeViLabel (input: $input ) {
      filmMasterID
      runID
      messageID
      mode
      workType
    }
  }
 `
